var map = {
	"./add-square-job.svg": 55951,
	"./address.svg": 77126,
	"./arrow-45deg.svg": 44081,
	"./arrow-down.svg": 21066,
	"./arrow-dropdown-resize.svg": 68062,
	"./arrow-expand.svg": 72862,
	"./arrow-left.svg": 78305,
	"./arrow-return.svg": 60368,
	"./arrow-up.svg": 84441,
	"./back-to-rework.svg": 67524,
	"./burger.svg": 16549,
	"./button-dropdown.svg": 75448,
	"./check-circle.svg": 96603,
	"./checked-round.svg": 91622,
	"./chevron-down.svg": 43612,
	"./chevron-for-dropdown.svg": 60885,
	"./chevron-left.svg": 35019,
	"./clip.svg": 64308,
	"./clock-upload.svg": 68114,
	"./clock.svg": 89500,
	"./close-bold.svg": 38382,
	"./close.svg": 94714,
	"./comment-arrow.svg": 76665,
	"./comment-template.svg": 77192,
	"./comment.svg": 63085,
	"./copy.svg": 32381,
	"./create-related-work.svg": 54210,
	"./delete-outline.svg": 10754,
	"./download.svg": 4462,
	"./edit-pencil.svg": 20336,
	"./edit-square-outline.svg": 15703,
	"./end-by-admin.svg": 70815,
	"./envelope.svg": 69854,
	"./favourite.svg": 40683,
	"./file-archive.svg": 49329,
	"./file-audio.svg": 25653,
	"./file-code.svg": 69966,
	"./file-excel.svg": 44274,
	"./file-image.svg": 91824,
	"./file-pdf.svg": 19161,
	"./file-powerpoint.svg": 37518,
	"./file-text.svg": 34236,
	"./file-universal.svg": 67636,
	"./file-video.svg": 11634,
	"./file-word.svg": 83877,
	"./filter.svg": 71580,
	"./flip-horizontal.svg": 30604,
	"./flip-vertical.svg": 21114,
	"./folder-closed-add.svg": 89353,
	"./folder-closed.svg": 16735,
	"./folder-open-add.svg": 29349,
	"./folder-open.svg": 97091,
	"./full-screen.svg": 5690,
	"./go-job.svg": 97210,
	"./hash.svg": 41202,
	"./info-circle-outline.svg": 42358,
	"./invalid.svg": 85027,
	"./lock.svg": 93543,
	"./logo.svg": 62879,
	"./logout.svg": 84396,
	"./options-menu.svg": 37380,
	"./park-outline_rotation.svg": 51020,
	"./person-success.svg": 75467,
	"./phone-called.svg": 21464,
	"./phone.svg": 24542,
	"./photo-add.svg": 72788,
	"./plus-circle.svg": 31743,
	"./plus.svg": 38610,
	"./related.svg": 64127,
	"./reply-left.svg": 74532,
	"./reply-right.svg": 62219,
	"./rollback.svg": 11958,
	"./rotate-left.svg": 11599,
	"./rotate-right.svg": 60778,
	"./search-magnify.svg": 27168,
	"./send-message.svg": 59746,
	"./send-to-check.svg": 54733,
	"./settings-outline.svg": 99760,
	"./share.svg": 65203,
	"./small-screen.svg": 6528,
	"./sort-auto.svg": 2522,
	"./sound-off.svg": 86219,
	"./sound-on.svg": 83055,
	"./unchecked-round.svg": 39361,
	"./user.svg": 59615,
	"./zoom-in.svg": 82785,
	"./zoom-out.svg": 77616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39603;